module.exports = __webpack_public_path__ + "img/Society2.1e5f75ce.jpg";